var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: {
        id: "place_form_modal",
        "no-close-on-backdrop": true,
        "hide-footer": true,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPreviousStep,
                        expression: "hasPreviousStep",
                      },
                    ],
                    staticClass: "mobile-previous-btn",
                    on: {
                      click: function ($event) {
                        return _vm.previousStep()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-arrow-left",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "22",
                          height: "22",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#253342",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "19", y1: "12", x2: "5", y2: "12" },
                        }),
                        _c("polyline", {
                          attrs: { points: "12 19 5 12 12 5" },
                        }),
                      ]
                    ),
                  ]
                ),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hasPreviousStep,
                      expression: "!hasPreviousStep",
                    },
                  ],
                  staticClass: "mobile-header-placeholder",
                }),
                _c("div", { staticClass: "mobile-header-placeholder" }),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close-modal-btn mr-7",
                      attrs: { id: "place_form_modal_close_btn" },
                      on: { click: close },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-x",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "28",
                            height: "28",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                          }),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasPreviousStep,
                          expression: "hasPreviousStep",
                        },
                      ],
                      staticClass: "previous-btn ml-7",
                      on: {
                        click: function ($event) {
                          return _vm.previousStep()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("placeFormModal.previousStepBtn")) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLastStep,
                        expression: "isLastStep",
                      },
                    ],
                    staticClass: "bb-btn btn-success header-save-btn",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("placeFormModal.saveBtn")) + " ")]
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isLastStep,
                        expression: "!isLastStep",
                      },
                    ],
                    staticClass: "bb-btn btn-success header-next-btn",
                    class: _vm.canGoToNextStep ? "" : "btn-disabled",
                    attrs: { disabled: !_vm.canGoToNextStep },
                    on: {
                      click: function ($event) {
                        return _vm.nextStep()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("placeFormModal.nextStepBtn")) + " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "modal-header-title-container" }, [
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasMultipleSteps,
                        expression: "hasMultipleSteps",
                      },
                    ],
                    staticClass: "steps-title",
                  },
                  [_vm._v(" " + _vm._s(_vm.stepsString) + " ")]
                ),
                _c("h2", [_vm._v(_vm._s(_vm.modalTitle))]),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.titleDescription,
                        expression: "titleDescription",
                      },
                    ],
                    staticClass: "title-description",
                  },
                  [_vm._v(" " + _vm._s(_vm.titleDescription) + " ")]
                ),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _vm.basicInfoVisible
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c("div", { staticClass: "bb-card basic-info-card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("placeFormModal.basicInfoCard.title")) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "place-logo-container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "place-logo-placeholder",
                        on: {
                          click: function ($event) {
                            return _vm.uploadLogo()
                          },
                        },
                      },
                      [
                        !_vm.form.fields.logo && !_vm.form.helpers.logo
                          ? _c(
                              "svg",
                              {
                                attrs: {
                                  width: "44",
                                  height: "48",
                                  viewBox: "0 0 44 48",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M25.7059 7.21622H5.94118C4.63069 7.21622 3.37389 7.74015 2.44724 8.67277C1.52059 9.60538 1 10.8703 1 12.1892V37.0541M1 37.0541V42.027C1 43.3459 1.52059 44.6108 2.44724 45.5434C3.37389 46.4761 4.63069 47 5.94118 47H35.5882C36.8987 47 38.1555 46.4761 39.0822 45.5434C40.0088 44.6108 40.5294 43.3459 40.5294 42.027V32.0811M1 37.0541L12.3301 25.651C13.2567 24.7187 14.5133 24.195 15.8235 24.195C17.1338 24.195 18.3903 24.7187 19.3169 25.651L25.7059 32.0811M40.5294 19.027V32.0811M40.5294 32.0811L36.6111 28.1375C35.6844 27.2052 34.4279 26.6815 33.1176 26.6815C31.8074 26.6815 30.5508 27.2052 29.6242 28.1375L25.7059 32.0811M25.7059 32.0811L30.6471 37.0541M33.1176 5.97297H43M38.0588 1V10.9459M25.7059 17.1622H25.7306",
                                    stroke: "#99ACC2",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        !_vm.form.fields.logo && !_vm.form.helpers.logo
                          ? _c(
                              "span",
                              { staticClass: "place-logo-description" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "placeFormModal.basicInfoCard.logoInput.label"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        !_vm.form.fields.logo && _vm.form.helpers.logo
                          ? _c("img", {
                              staticClass: "logo-preview",
                              attrs: { src: _vm.form.helpers.logo },
                            })
                          : _vm._e(),
                        _vm.form.fields.logo
                          ? _c("img", {
                              staticClass: "logo-preview",
                              attrs: { src: _vm.logoUrl },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c("input", {
                      ref: "logoInput",
                      staticStyle: { display: "none" },
                      attrs: { type: "file" },
                      on: { change: _vm.onFileChange },
                    }),
                    _c("span", { staticClass: "place-logo-description" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "placeFormModal.basicInfoCard.logoInput.description"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.logoError || _vm.form.errors.logo,
                            expression: "logoError || form.errors.logo",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.logoError || _vm.form.errors.logo) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "bb-form-group mt-12" }, [
                    _c("label", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "placeFormModal.basicInfoCard.nameInput.label"
                            )
                          ) +
                          " "
                      ),
                      _c("span", { staticClass: "bb-label-descrition" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "placeFormModal.basicInfoCard.nameInput.description"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.name,
                          expression: "form.fields.name",
                        },
                      ],
                      staticClass: "bb-input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form.fields, "name", $event.target.value)
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.name,
                            expression: "form.errors.name",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [_vm._v(" " + _vm._s(_vm.form.errors.name) + " ")]
                    ),
                  ]),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "placeFormModal.basicInfoCard.publicProfileInput.label"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "bb-input-group" }, [
                      _c("span", [_vm._v("bookybook.rs/")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.fields.publicProfile,
                            expression: "form.fields.publicProfile",
                          },
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.form.fields.publicProfile },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.fields,
                              "publicProfile",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.publicProfile,
                            expression: "form.errors.publicProfile",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.form.errors.publicProfile) + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "placeFormModal.basicInfoCard.phoneInput.label"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "bb-input-group" }, [
                      _c("span", [_vm._v("+381")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.fields.phone,
                            expression: "form.fields.phone",
                          },
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.form.fields.phone },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.fields,
                              "phone",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.phone,
                            expression: "form.errors.phone",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [_vm._v(" " + _vm._s(_vm.form.errors.phone) + " ")]
                    ),
                  ]),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "placeFormModal.basicInfoCard.emailInput.label"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.email,
                          expression: "form.fields.email",
                        },
                      ],
                      staticClass: "bb-input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "email",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.email,
                            expression: "form.errors.email",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [_vm._v(" " + _vm._s(_vm.form.errors.email) + " ")]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bb-form-group" },
                    [
                      _c("label", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "placeFormModal.basicInfoCard.descriptionInput.label"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("b-form-textarea", {
                        staticClass: "bb-textarea",
                        attrs: { rows: "4" },
                        model: {
                          value: _vm.form.fields.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "description", $$v)
                          },
                          expression: "form.fields.description",
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.description,
                              expression: "form.errors.description",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.form.errors.description) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "placeFormModal.basicInfoCard.maxReservationInput.label"
                            )
                          ) +
                          " "
                      ),
                      _c("span", { staticClass: "bb-label-descrition" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "placeFormModal.basicInfoCard.maxReservationInput.description"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "bb-input-group" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "placeFormModal.basicInfoCard.maxReservationInput.shortDescription"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.fields.maxReservations,
                            expression: "form.fields.maxReservations",
                          },
                        ],
                        attrs: {
                          type: "number",
                          min: "1",
                          max: "100",
                          step: "1",
                        },
                        domProps: { value: _vm.form.fields.maxReservations },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.fields,
                              "maxReservations",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.maxReservations,
                            expression: "form.errors.maxReservations",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.form.errors.maxReservations) + " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.mainCategoryVisible
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c("CategoriesInput", {
                attrs: {
                  allCategories: _vm.allCategories,
                  selected: _vm.form.fields.mainCategory,
                },
                on: {
                  valueUpdated: function ($event) {
                    return _vm.updateMainCategory($event)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.mainCategory,
                      expression: "form.errors.mainCategory",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("placeFormModal.validation.mainCategoryError")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.additionalCategoriesVisible
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c("CategoriesInput", {
                attrs: {
                  allCategories: _vm.allCategories,
                  multiple: true,
                  selected: _vm.form.fields.additionalCategories,
                  disabled: [_vm.form.fields.mainCategory],
                },
                on: {
                  valueUpdated: function ($event) {
                    return _vm.updateAdditionalCategories($event)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.additionalCategories,
                      expression: "form.errors.additionalCategories",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.form.errors.additionalCategories) + " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.locationVisible
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c(
                "div",
                { staticClass: "location-input-container" },
                [
                  _c("LocationInput", {
                    attrs: {
                      latitude: _vm.form.fields.latitude,
                      longitude: _vm.form.fields.longitude,
                      locationName: _vm.form.fields.name,
                      address: _vm.form.fields.address,
                    },
                    on: {
                      updateLocation: function ($event) {
                        return _vm.updateLocationFields($event)
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.errors.latitude ||
                            _vm.form.errors.longitude ||
                            _vm.form.errors.address,
                          expression:
                            "\n                    form.errors.latitude ||\n                    form.errors.longitude ||\n                    form.errors.address\n                ",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("placeFormModal.validation.locationError")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "mobile-footer" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLastStep,
                expression: "isLastStep",
              },
            ],
            staticClass: "bb-btn btn-success",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("placeFormModal.saveBtn")) + " ")]
        ),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLastStep,
                expression: "!isLastStep",
              },
            ],
            staticClass: "bb-btn btn-success",
            class: _vm.canGoToNextStep ? "" : "btn-disabled",
            attrs: { disabled: !_vm.canGoToNextStep },
            on: {
              click: function ($event) {
                return _vm.nextStep()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("placeFormModal.nextStepBtn")) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }